import SegmentEntity from '../segment-entity/segment-entity';
import CuePointEntity from '../cue-point-entity/cue-point-entity';
import {
  CuePointMetadata,
  SourceWithoutProperties
} from '../presentation-config-aggregate-types/presentation-config-aggregate-types';

export interface IPresenterSlideEntity {

    getSegment(): SegmentEntity;

    getCuePoint(): CuePointEntity;

    getCuePointMetadata(): CuePointMetadata;

    getCuePointSource(): SourceWithoutProperties;

    getCuePointId() : string;

    setCuePointMetadata(metadata:CuePointMetadata) : void;
}

class PresenterSlideEntity implements IPresenterSlideEntity {
  constructor (
        private segment: SegmentEntity,
        private cuepoint: CuePointEntity) {
  }

  public getSegment (): SegmentEntity {
    return this.segment;
  }

  public getCuePoint (): CuePointEntity {
    return this.cuepoint;
  }

  public getCuePointId () : string {
    return this.cuepoint.getCuePointId();
  }

  public getCuePointMetadata (): CuePointMetadata {
    return this.cuepoint.getMetadata();
  }

  public getCuePointSource (): SourceWithoutProperties {
    return this.cuepoint.getSource();
  }

  public setCuePointMetadata (metadata: CuePointMetadata): void {
    this.cuepoint.setMetadata(metadata);
  }
}

export { PresenterSlideEntity };
